/* eslint-disable react/prop-types */
import React, { Fragment, useContext } from 'react';

import Responsive from 'app/components/Responsive';
import { LocaleContext } from 'app/containers/LocaleProvider';

import PortionLine from './dishes/BlackheadDishes/Portion';



const MobileSmallDishDetails = (props) => {
    const { locale } = useContext(LocaleContext);

    const {
        dish: { description },
        dish,
        index,
    } = props;

    const image = dish.imageUrlDetails || dish.imageUrl;

    const titles = {
        ru: dish.title,
        en: dish.titleEn,
    };
    const portionsTexts = {
        ru: dish.portionsText,
        en: dish.portionsTextEn,
    };
    const weightTexts = {
        ru: dish.weightText,
        en: dish.weightTextEn,
    };

    const title = titles[locale];
    const portionText = portionsTexts[locale];
    const weightText = weightTexts[locale];

    return (
        <div className="promo-set-details--wrapper" data-list-index={index}>
            <div className="promo-set-details-image">
                <picture>
                    <source srcSet={image} />
                    <img
                        alt={dish.title.join(' ')}
                        className="promo-set-details-image__item"
                    />
                </picture>
            </div>
            <div className="promo-set-details-text">
                <div className="promo-set-details-text__title LP_H5-1">
                    {title.map((line, i) => (
                        <Fragment key={line}>
                            {i !== 0 && <br />}
                            <span className="blackhead-dish-description__title-line">{line}</span>
                        </Fragment>
                    ))}
                </div>
                <div className="promo-set-details-text__portion">
                    <PortionLine
                        weightValue={dish.weightValue}
                        portions={dish.portions}
                        text={portionText}
                        weightText={weightText}
                    />
                </div>
                <div
                    className="promo-set-details-text__description LP_p1-1"
                >
                    <span>{description}</span>
                </div>
            </div>
        </div>
    );
};

const DesktopSmallDishDetails = (props) => {
    const { locale } = useContext(LocaleContext);

    const {
        dish: { description },
        dish,
        index,
    } = props;

    const titles = {
        ru: dish.title,
        en: dish.titleEn,
    };
    const portionsTexts = {
        ru: dish.portionsText,
        en: dish.portionsTextEn,
    };
    const weightTexts = {
        ru: dish.weightText,
        en: dish.weightTextEn,
    };

    const title = titles[locale];
    const portionText = portionsTexts[locale];
    const weightText = weightTexts[locale];

    const imgDesktop = dish.imageUrlDetailsDesktop || dish.imageUrlDesktop || dish.imageUrl;

    return (
        <div className="d-promo-set-details--wrapper" data-list-index={index}>
            <div className="d-promo-set-details-image">
                {/* <div className="d-promo-set-details-image__item" /> */}
                <picture>
                    <source srcSet={imgDesktop} />
                    <img
                        alt={dish.title.join(' ')}
                        className="d-promo-set-details-image__item"
                    />
                </picture>
            </div>
            <div className="d-promo-set-details-text">
                <div className="d-promo-set-details-text__title">
                    {title.map((line, i) => (
                        <Fragment key={line}>
                            {i !== 0 && <br />}
                            <span className="blackhead-dish-description__title-line">{line}</span>
                        </Fragment>
                    ))}
                </div>
                <div className="d-promo-set-details-text__portion">
                    <PortionLine
                        weightValue={dish.weightValue}
                        portions={dish.portions}
                        text={portionText}
                        weightText={weightText}
                    />
                </div>
                <div className="d-promo-set-details-text__description">
                    <span className="LPd_p2-1">{description}</span>
                </div>
            </div>
        </div>
    );
};

const PromoSetDishDetails = (props) => (
    <Responsive
        mobile={<MobileSmallDishDetails {...props} />}
        desktop={<DesktopSmallDishDetails {...props} />}
    />
);
export default PromoSetDishDetails;
